import styled from "styled-components";

export const Seccion = styled.h1`
  width: 200px;
  font-weight: 800;
  font-size: 24px;
  font-family: 'Montserrat', sans-serif;
  text-align: left;
  color: #003049;
`;

export const ImageProfile = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  font-size: 16px;
  background-color: ${props => props.backgroundColor};
  font-family: 'Montserrat', sans-serif;
`;

export const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  align-content: flex-start;
`;

export const NombreApellido = styled.div`
  color: #1A1C21;
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.07px;
`;

export const Cargo = styled.div`
  color: #667085;
  font-family: 'Montserrat', sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.06px;
`;

export const StatusConnectUser = styled.div`
  background-color: ${(prop) => prop.status ? 'green' : 'red'};
  width: 10px;
  height: 10px;
  border-radius: 50%;
  position: relative;
  top: -15px;
  left: 19px;
  border: solid 2px white;
  box-sizing: content-box;
`;

export const ContentImageProfile = styled.div`
  width: 32px;
  height: 32px;
  margin-right: 5px;
`;

export const FlexRow2 = styled.div`
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  gap: 5px;
  width: auto;
`;

export const FlexRow = styled.div`
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  position: relative;
  gap: 5px;
  width: 100%;
  padding-left: ${(prop) => prop.onlyWidth < 1100 ? "0px" : "257px"};
`;

export const Container = styled.div`
  z-index: 2;
  width: 100%;
  height: auto;
  padding: 16px 24px;
  background-color: #FFFFFF;
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
  align-items: center;
  justify-content: flex-end;
  position: fixed;
  box-shadow: 0px 1.5px 2px rgba(16, 24, 40, 0.1);
`;

export const Icon = styled.img`
  width: 24px;
  height: 24px;
  transition: transform 0.3s ease-in;
  cursor: pointer;
  ${(props) => props.open && `transform: rotate(180deg);`}
`;

export const Dropdown = styled.div`
  position: absolute;
  left: 0;
  bottom: -38%;
  transform: translate(0, 100%);
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  display:${(prop) => (prop.open ? "auto" : "none")};
  width: 100%;
  height: ${(prop) => (prop.open ? "auto" : "0px")};
  background-color: #FFFFFF;
  overflow: hidden;
  transition: height 0.3s ease-in-out;
  padding:10px;
  border-radius:8px;
  box-shadow: 
        0px 3.200000047683716px 7.199999809265137px 0px rgba(0, 48, 72, 0.12), 
        0px 0.6000000238418579px 1.7999999523162842px 0px rgba(0, 48, 72, 0.10);

  a, button {
    display: block;
    width: fit-content;
    background: none;
    border: none;
    text-decoration: none;
    font-family: 'Montserrat', sans-serif;
    font-size: 16px;
    font-weight: 600;
    color: #17223c;
    transition: color 0.3s ease-in-out;
  }
`;
